// Folha com uma lista de pessoas, cada uma com o botão de amizade: quem está na sala (lista de salas) e os 3 de um
// trio (ranking). Bot aparece sem botão; você aparece como "Você".
import { createPortal } from 'react-dom';
import { BotaoAmizade } from './BotaoAmizade.tsx';
import { BotaoPerfil } from './BotaoPerfil.tsx';
import { Rosto } from './Rosto.tsx';

export type PessoaNaFolha = { id: string; apelido: string; avatar: string | null } | { bot: true; apelido: string };

export function FolhaDePessoas({ titulo, subtitulo, pessoas, eu, aoFechar }: {
  titulo: string; subtitulo?: string; pessoas: PessoaNaFolha[]; eu: string; aoFechar: () => void;
}) {
  // Num portal: a folha não herda a opacidade nem o recorte do cartão de onde abriu.
  return createPortal(
    <div className="folha-fundo" onClick={(ev) => { if (ev.target === ev.currentTarget) aoFechar(); }}>
      <div className="folha simples" role="dialog" aria-modal="true" aria-labelledby="folha-pessoas">
        <h2 id="folha-pessoas">{titulo}</h2>
        {subtitulo && <p className="nota">{subtitulo}</p>}
        <ul className="lista-pessoas">
          {pessoas.map((j, i) => (
            <li key={'id' in j ? j.id : 'bot' + i}>
              {'id' in j ? (
                <BotaoPerfil usuario={j.id} apelido={j.id === eu ? 'você' : j.apelido}>
                  <Rosto perfil={{ apelido: j.apelido, avatar: j.avatar }} usuario={j.id} cor="var(--line-600)" tamanho={40} />
                  <span className="nome"><b>{j.id === eu ? 'Você' : j.apelido}</b></span>
                </BotaoPerfil>
              ) : (
                <>
                  <Rosto perfil={{ apelido: j.apelido, avatar: null }} bot cor="var(--line-600)" tamanho={40} />
                  <span className="nome"><b>{j.apelido}</b><small>BOT</small></span>
                </>
              )}
              {'id' in j && j.id !== eu && <BotaoAmizade usuario={j.id} apelido={j.apelido} compacto />}
            </li>
          ))}
        </ul>
        <button className="btn2" onClick={aoFechar}>Fechar</button>
      </div>
    </div>,
    document.body,
  );
}
